<template>
  <main role="main" id="main-lesson">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link to="/thu-vien">Danh sách đề thi</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="pre-lesson__main">
      <div class="container-hts">
        <FilterList />
            <div class="pre-lesson__list">
          <div class="row">
            <div  v-for="item in exams" :key="item.Id" class="item col-lg-3 col-md-4 col-sm-6">
              <div class="item__wrap">
                <div class="item__head aspect-ratio aspect-ratio--16-9 text-center border-rd-4 bg-transparent">
                  <router-link  :to="{ name: 'examAdd', params: { id: item.examId }}" class="display-block">
                    <div class="item__img" :id="item.lessonPlanId">
                      <img :src="`${baseUrl}/${item.avatar}`" :alt="item.name">
                    </div>
                  </router-link>
                </div>
                <div class="item__body">
                  <h3 class="primary-color-txt margin-0 font-size-16 primary-color-txt font-sanpro-semibold">
                    <router-link  :to="{ name: 'examAdd', params: { id: item.examId }}" class="primary-color-txt">
                      {{ item.name }}
                    </router-link>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </main>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import examService from './../_api/examService'
    import FilterList from './../_components/list/FilterList'
    import { STORE_KEY } from './../_store/constants'
    import { APP_CONFIG } from "@/utils/constants";
    import { apiGetListClassOfTeacher,apiGetListSubjectOfTeacher } from './../_api/exam'
    
    export default {
        name: 'ExamList',
        components: {
          FilterList
        },
        data() {
          return {
            loadMore: true,
            exams: [],
            uploadUrl: APP_CONFIG.uploadUrl,
            cdnUrl: APP_CONFIG.cdnUrl,
            baseUrl: APP_CONFIG.appUrl,
          }
        },
        computed: {
          ...mapState(STORE_KEY, ['paramSearch'])
        },
        watch: {
          'paramSearch.classId': 'handleFilterExams',
          'paramSearch.subjectId': 'handleFilterExams',
          'paramSearch.keyword': 'handleFilterExams'
        },
        created() {
            this.getExams()
            // this.getListClassOfTeacher();
            // this.changeClass();
        },
        mounted(){
          // window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
          // document.body.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            ...mapActions('common', ['setLoading']),
            ...mapActions(STORE_KEY, ['acSetParamSearch']),

            search(){
                this.loadMore = true;
                this.pageIndex = 1;
                this.exams = [];
                this.getExams();
            },
            
            thumbUrl(filename) {
                return require(`@/assets/images/${filename}`);
            },
            gotoLessonPage(){
                this.$router.push('/danh-sach-giao-an');
            },

            handleScroll (e){
              if(window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 5 && this.loadMore){
                this.acSetParamSearch({...this.paramSearch, pageIndex: this.paramSearch.pageIndex + 1})
                this.getExams();
              }
            },

            async handleFilterExams () {
              this.loadMore = true;
              this.exams = [];
              await this.acSetParamSearch({...this.paramSearch, pageIndex: 1})
              this.getExams()
            },
            
            getExams(){
                let self = this;
                self.setLoading(true);
                examService.filter(this.paramSearch)
                .then((response) => {
                    if(this.pageIndex == 1){
                        this.exams = response.data.data.list;
                    }
                    else{
                        this.exams = this.exams.concat(response.data.data.list);
                    }
                    if(this.exams.length >= response.data.data.paging.totalRecords){
                        this.loadMore = false;
                    }
                }).catch(e => {
                    this.errors.push(e)
                }).finally(() => { self.setLoading(false)});
            },
            // getListClassOfTeacher(){
            //   apiGetListClassOfTeacher().then(res=>{

            //     this.classes = res.data
            //     console.log('333333333333',  this.classes);
            //   })
            // },
            // changeClass(){
            //   apiGetListSubjectOfTeacher({classId:this.filter.classId}).then(res => {
            //     this.subjects = res.data
            //     console.log('vao vao vao ',this.subjects);
            //   })
            // },
            // apiGetListSubjectOfTeacher({classId:res.data.classId}).then(res => {
            //     this.listsubjects = res.data
            //   })
            // getClasses(){
            //     classService.get()
            //     .then((response) => {
            //         this.classes = response.data.data;
            //     }).catch(e => {
            //         console.log(e);
            //     })
            //     .finally();
            // },
            getSubjects(){
                this.classes.forEach((item, i) => {
                    if (item.Id == this.filter.classId) {
                        this.subjects = item.Subjects;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
  .pre-lesson {

    &__list {
      padding: 15px 0;

      .item {
        margin-bottom: 30px;

        &__body {
          padding: 10px 0;
        }

        &:hover {
          .item {
            &__head {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }
</style>